'use strict';

import DashboardDataProvider from './dashboardDataProvider';
import DashboardPanel from './dashboard.panel.ctrl';

import DashboardSmallWidget from './components/dashboardSmallWidget/dashboardSmallWidget';
import DashboardWidget from './components/dashboardWidget/dashboardWidget';
import ChartPage from './components/chartPage/chartPage';

import SubscriptionsTotalWidget from './widgets/subscriptionsTotalWidget/subscriptionsTotalWidget';
import LocationsTotalWidget from './widgets/locationsTotalWidget/locationsTotalWidget';
import UsersActiveWidget from './widgets/usersActiveWidget/usersActiveWidget';
import UsersDailyWidget from './widgets/usersDailyWidget/usersDailyWidget';
import UsersNewWidget from './widgets/usersNewWidget/usersNewWidget.js';
import DevicesTotalWidget from './widgets/devicesTotalWidget/devicesTotalWidget';
import SubscriptionsWidget from './widgets/subscriptionsWidget/subscriptionsWidget';
import AlertsWidget from './widgets/alertsWidget/alertsWidget';
import GatewaysTotalWidget from './widgets/gatewaysTotalWidget/gatewaysTotalWidget';
import GatewaysConnectivityWidget from './widgets/gatewaysConnectivityWidget/gatewaysConnectivityWidget';

import UsersActivePage from './pages/usersActivePage/usersActivePage';
import UsersNewPage from './pages/usersNewPage/usersNewPage';
import SubscriptionsTotalPage from './pages/subscriptionsTotalPage/subscriptionsTotalPage';
import LocationsTotalPage from './pages/locationsTotalPage/locationsTotalPage';
import SubscriptionsPage from './pages/subscriptionsPage/subscriptionsPage';
import AlertsPage from './pages/alertsPage/alertsPage';
import DevicesTotalPage from './pages/devicesTotalPage/devicesTotalPage';
import GatewaysTotalPage from './pages/gatewaysTotalPage/gatewaysTotalPage';
import GatewaysConnectivityPage from './pages/gatewaysConnectivityPage/gatewaysConnectivityPage';

import DashboardChart from './charts/dashboardChart/dashboardChart';
import DashboardBarChart from './charts/dashboardBarChart/dashboardBarChart';
import HorizontalBarMiniChart from './charts/horizontalBarMiniChart/horizontalBarMiniChart';
import CombinedChart from './charts/combinedChart/combinedChart';

export default angular
  .module('main.dashboard', [
    DashboardDataProvider,
    DashboardPanel,

    DashboardSmallWidget,
    DashboardWidget,

    SubscriptionsTotalWidget,
    LocationsTotalWidget,
    UsersActiveWidget,
    UsersDailyWidget,
    UsersNewWidget,
    DevicesTotalWidget,
    SubscriptionsWidget,
    AlertsWidget,
    GatewaysTotalWidget,
    GatewaysConnectivityWidget,

    ChartPage,
    UsersActivePage,
    UsersNewPage,
    SubscriptionsTotalPage,
    LocationsTotalPage,
    SubscriptionsPage,
    AlertsPage,
    DevicesTotalPage,
    GatewaysTotalPage,
    GatewaysConnectivityPage,

    DashboardChart,
    DashboardBarChart,
    HorizontalBarMiniChart,
    CombinedChart
  ])
  .name;
